(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/internal/client/campaigns-singleton.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/internal/client/campaigns-singleton.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const logger = svs.numbergames.campaign.logger;
const {
  DRAW_STATE,
  DRAW_TYPE
} = svs.numbergames.campaign.CONSTANTS;
const {
  getValidProduct,
  getCampaignProducts,
  getValidYear,
  getValidMonth
} = svs.numbergames.campaign.internal.utils;
const {
  isRelevantCampaign,
  filterCampaignsByDrawTypeId,
  filterCampaignsByDrawStateId,
  filterCampaignsByDraw,
  filterCampaignsByDate,
  filterCampaignsByEndDateInterval,
  filterCampaignsByInterval
} = svs.numbergames.campaign.internal.filterCampaigns;
var _activeCampaignsFetched = new WeakMap();
var _campaigns = new WeakMap();
var _datePicker = new WeakMap();
var _fetchingActiveCampaigns = new WeakMap();
var _fetchingCampaignByDraw = new WeakMap();
var _fetchingCampaignDatePicker = new WeakMap();
var _fetchActiveCampaigns = new WeakMap();
var _fetchCampaignByDraw = new WeakMap();
var _fetchCampaignDatePicker = new WeakMap();
var _updateActiveCampaigns = new WeakMap();
var _updateCampaignByDraw = new WeakMap();
var _updateDatePicker = new WeakMap();
class Campaign {
  constructor() {
    var _campaignsActive$data;
    _classPrivateFieldInitSpec(this, _activeCampaignsFetched, getCampaignProducts().reduce((acc, product) => Object.assign(acc, {
      [product]: false
    }), {}));
    _classPrivateFieldInitSpec(this, _campaigns, getCampaignProducts().reduce((acc, product) => Object.assign(acc, {
      [product]: {}
    }), {}));
    _classPrivateFieldInitSpec(this, _datePicker, getCampaignProducts().reduce((acc, product) => Object.assign(acc, {
      [product]: {}
    }), {}));
    _classPrivateFieldInitSpec(this, _fetchingActiveCampaigns, void 0);
    _classPrivateFieldInitSpec(this, _fetchingCampaignByDraw, void 0);
    _classPrivateFieldInitSpec(this, _fetchingCampaignDatePicker, void 0);
    _classPrivateFieldInitSpec(this, _fetchActiveCampaigns, async product => {
      const promise = (async () => {
        try {
          await _classPrivateFieldGet(_fetchingActiveCampaigns, this);
        } catch (error) {
          logger.info('Previous fetch failed', error);
        }
        if (_classPrivateFieldGet(_activeCampaignsFetched, this)[product]) {
          return; 
        }
        let campaigns;
        try {
          var _data$response$campai, _data$response;
          const data = await drawgamesApiCaller.getDrawActiveCampaignsByProduct({
            product
          });
          campaigns = (_data$response$campai = data === null || data === void 0 || (_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.campaigns) !== null && _data$response$campai !== void 0 ? _data$response$campai : [];
        } catch (error) {
          logger.warn('Campaign.#fetchActiveCampaigns failed to fetch campaigns', error);
          return;
        }
        _classPrivateFieldGet(_updateActiveCampaigns, this).call(this, campaigns, [product]);
      })();
      _classPrivateFieldSet(_fetchingActiveCampaigns, this, promise);
      return await promise;
    });
    _classPrivateFieldInitSpec(this, _fetchCampaignByDraw, async (product, drawNumber) => {
      const promise = (async () => {
        try {
          await _classPrivateFieldGet(_fetchingCampaignByDraw, this);
        } catch (error) {
          logger.warn('Previous fetch failed', error);
        }
        if (!product || !drawNumber) {
          return; 
        }
        if (_classPrivateFieldGet(_campaigns, this)[product][drawNumber] && !_classPrivateFieldGet(_campaigns, this)[product][drawNumber].isDatePicker) {
          return; 
        }
        let campaign;
        try {
          var _data$response$campai2, _data$response2;
          const data = await drawgamesApiCaller.getDrawCampaignByCampaignDraw({
            product,
            drawNumber
          });
          campaign = (_data$response$campai2 = data === null || data === void 0 || (_data$response2 = data.response) === null || _data$response2 === void 0 ? void 0 : _data$response2.campaign) !== null && _data$response$campai2 !== void 0 ? _data$response$campai2 : {};
        } catch (error) {
          logger.warn('Campaign.#fetchCampaignByDraw failed to fetch campaign', error);
          return;
        }
        if (campaign.drawTypeId === DRAW_TYPE.PERIODIC && campaign.drawStateId === DRAW_STATE.FINALIZED) {
          try {
            var _data$response$campai3, _data$response3;
            const data = await drawgamesApiCaller.getDrawCampaignResultByDraw({
              product,
              drawNumber
            });
            campaign.winningLocations = (_data$response$campai3 = data === null || data === void 0 || (_data$response3 = data.response) === null || _data$response3 === void 0 || (_data$response3 = _data$response3.campaignResult) === null || _data$response3 === void 0 ? void 0 : _data$response3.winningLocations) !== null && _data$response$campai3 !== void 0 ? _data$response$campai3 : [];
          } catch (error) {
            logger.warn('Campaign.#fetchCampaignByDraw failed to fetch campaign result', error);
          }
        }
        _classPrivateFieldGet(_updateCampaignByDraw, this).call(this, campaign);
      })();
      _classPrivateFieldSet(_fetchingCampaignByDraw, this, promise);
      return await promise;
    });
    _classPrivateFieldInitSpec(this, _fetchCampaignDatePicker, async (product, date) => {
      const promise = (async () => {
        try {
          await _classPrivateFieldGet(_fetchingCampaignDatePicker, this);
        } catch (error) {
          logger.info('Previous fetch failed', error);
        }
        const year = getValidYear({
          date
        });
        const month = getValidMonth({
          date
        });
        if (!product || !year || !month) {
          return; 
        }
        if (_classPrivateFieldGet(_datePicker, this)[product]["".concat(year, "-").concat(month)]) {
          return; 
        }
        let datePicker;
        try {
          var _data$response4;
          const data = await drawgamesApiCaller.getDrawCampaignDatePicker({
            product,
            year,
            month
          });
          datePicker = (_data$response4 = data === null || data === void 0 ? void 0 : data.response) !== null && _data$response4 !== void 0 ? _data$response4 : {};
        } catch (error) {
          logger.warn('Campaign.#fetchCampaignDatePicker failed to fetch datepicker', error);
          return;
        }
        _classPrivateFieldGet(_updateDatePicker, this).call(this, datePicker);
      })();
      _classPrivateFieldSet(_fetchingCampaignDatePicker, this, promise);
      return await promise;
    });
    _classPrivateFieldInitSpec(this, _updateActiveCampaigns, (campaigns, products) => {
      products.forEach(product => {
        _classPrivateFieldGet(_activeCampaignsFetched, this)[product] = true;
      });
      campaigns.forEach(campaign => {
        _classPrivateFieldGet(_updateCampaignByDraw, this).call(this, campaign);
      });
    });
    _classPrivateFieldInitSpec(this, _updateCampaignByDraw, campaign => {
      if (!isRelevantCampaign(campaign)) {
        return;
      }
      const product = getValidProduct(campaign.products[0].productId);
      const drawNumber = campaign.drawNumber;
      if (!_classPrivateFieldGet(_campaigns, this)[product][drawNumber] || _classPrivateFieldGet(_campaigns, this)[product][drawNumber].isDatePicker) {
        _classPrivateFieldGet(_campaigns, this)[product][drawNumber] = campaign;
      }
    });
    _classPrivateFieldInitSpec(this, _updateDatePicker, datePicker => {
      const product = getValidProduct(datePicker.product);
      if (!product) {
        return;
      }
      const campaigns = datePicker.campaigns.filter(isRelevantCampaign);
      _classPrivateFieldGet(_datePicker, this)[product]["".concat(datePicker.year, "-").concat(datePicker.month)] = campaigns;
      campaigns.forEach(campaign => {
        _classPrivateFieldGet(_updateCampaignByDraw, this).call(this, _objectSpread(_objectSpread({}, campaign), {}, {
          isDatePicker: true
        }));
      });
    });
    const {
      campaigns_active: campaignsActive,
      campaigns_draw: campaignsDraw,
      campaigns_datepicker: campaignsDatepicker
    } = svs.numbergames;
    if (campaignsActive !== null && campaignsActive !== void 0 && (_campaignsActive$data = campaignsActive.data) !== null && _campaignsActive$data !== void 0 && _campaignsActive$data.campaigns) {
      _classPrivateFieldGet(_updateActiveCampaigns, this).call(this, campaignsActive.data.campaigns, getCampaignProducts());
    }
    if (campaignsDraw !== null && campaignsDraw !== void 0 && campaignsDraw.data) {
      Object.values(campaignsDraw === null || campaignsDraw === void 0 ? void 0 : campaignsDraw.data).forEach(_classPrivateFieldGet(_updateCampaignByDraw, this));
    }
    if (campaignsDatepicker !== null && campaignsDatepicker !== void 0 && campaignsDatepicker.data) {
      Object.values(campaignsDatepicker === null || campaignsDatepicker === void 0 ? void 0 : campaignsDatepicker.data).forEach(_classPrivateFieldGet(_updateDatePicker, this));
    }
  }
  findCampaigns(_ref) {
    let {
      product,
      draws,
      date,
      dateInterval,
      endDateInterval,
      year,
      month,
      drawTypeIds,
      drawStateIds
    } = _ref;
    let campaigns = Object.values(_classPrivateFieldGet(_campaigns, this)[product]);
    if (Array.isArray(drawTypeIds) && drawTypeIds.length) {
      campaigns = filterCampaignsByDrawTypeId(campaigns, drawTypeIds);
    }
    if (Array.isArray(drawStateIds) && drawStateIds.length) {
      campaigns = filterCampaignsByDrawStateId(campaigns, drawStateIds);
    }
    if (draws) {
      campaigns = filterCampaignsByDraw(campaigns, draws);
    }
    if (date) {
      campaigns = filterCampaignsByDate(campaigns, date);
    }
    if (endDateInterval) {
      campaigns = filterCampaignsByEndDateInterval(campaigns, endDateInterval);
    }
    if (dateInterval) {
      campaigns = filterCampaignsByInterval(campaigns, dateInterval);
    }
    if (year && month) {
      const startOfMonth = new Date(year, month - 1, 1);
      campaigns = filterCampaignsByInterval(campaigns, {
        startDate: startOfMonth,
        endDate: dateFns.endOfMonth(startOfMonth)
      });
    }
    const sortWeight = {
      [DRAW_STATE.DEFINED]: 3,
      [DRAW_STATE.OPEN]: 1,
      [DRAW_STATE.REG_CLOSED]: 2,
      [DRAW_STATE.CANCEL_CLOSED]: 2,
      [DRAW_STATE.FINALIZED]: 2
    };
    campaigns.sort((a, b) => sortWeight[a.drawStateId] - sortWeight[b.drawStateId] || new Date(a.startDate) - new Date(b.startDate));
    logger.debug('Campaigns returned from findCampaigns', campaigns);
    return campaigns;
  }
  async fetchCampaigns(_ref2) {
    let {
      product,
      draws,
      date,
      dateInterval,
      endDateInterval,
      year,
      month,
      drawTypeIds,
      drawStateIds
    } = _ref2;
    await _classPrivateFieldGet(_fetchActiveCampaigns, this).call(this, product);
    if (year && month) {
      await _classPrivateFieldGet(_fetchCampaignDatePicker, this).call(this, product, new Date(year, month - 1, 1));
    }
    if (dateInterval) {
      const datesToFetch = dateFns.eachMonthOfInterval({
        start: new Date(dateInterval.startDate),
        end: new Date(dateInterval.endDate)
      });
      await Promise.all(datesToFetch.map(date => _classPrivateFieldGet(_fetchCampaignDatePicker, this).call(this, product, date)));
    }
    if (endDateInterval) {
      const datesToFetch = dateFns.eachMonthOfInterval({
        start: new Date(endDateInterval.startDate),
        end: new Date(endDateInterval.endDate)
      });
      await Promise.all(datesToFetch.map(date => _classPrivateFieldGet(_fetchCampaignDatePicker, this).call(this, product, date)));
      const campaigns = filterCampaignsByEndDateInterval(Object.values(_classPrivateFieldGet(_campaigns, this)[product]), endDateInterval);
      await Promise.all(campaigns.map(campaign => _classPrivateFieldGet(_fetchCampaignByDraw, this).call(this, product, campaign.drawNumber)));
    }
    if (date) {
      await _classPrivateFieldGet(_fetchCampaignDatePicker, this).call(this, product, date);
      const campaigns = filterCampaignsByDate(Object.values(_classPrivateFieldGet(_campaigns, this)[product]), date);
      await Promise.all(campaigns.map(campaign => _classPrivateFieldGet(_fetchCampaignByDraw, this).call(this, product, campaign.drawNumber)));
    }
    if (draws) {
      const campaigns = filterCampaignsByDraw(Object.values(_classPrivateFieldGet(_campaigns, this)[product]), draws);
      await Promise.all(campaigns.map(campaign => _classPrivateFieldGet(_fetchCampaignByDraw, this).call(this, product, campaign.drawNumber)));
    }
    return this.findCampaigns({
      product,
      draws,
      date,
      dateInterval,
      endDateInterval,
      year,
      month,
      drawTypeIds,
      drawStateIds
    });
  }
}
svs.numbergames.campaign.internal.campaignsSingleton = new Campaign();

 })(window);